import {Injectable, inject} from '@angular/core';
import {StoreSummary} from '../../classes/models/store/StoreSummary';
import {DataService} from './data.service';
import {Router} from '@angular/router';
import {RuleCheckerService} from './rule-checker.service';

/**
 * This service handles selecting and unselecting the store.
 */
@Injectable({
  providedIn: 'root'
})
export class ChangeStoreService {
  private dataService = inject(DataService);
  private router = inject(Router);
  private ruleCheckerService = inject(RuleCheckerService);


  /**
   * Clears selected store and error messages, associated with that store. Navigates to the homepage where a user could select a new store.
   */
  unselectStore() {
    this.dataService.selectedStore = null;
    this.router.navigate(['/']);
    this.ruleCheckerService.rotaErrors.set([]);
  }

  /**
   * Saves selected store to the local storage. Finds error messages for the store.
   * @param store the selected store.
   */
  selectStore(store: StoreSummary) {
    this.dataService.selectedStore = store;
    this.redirectTo(store);
    this.ruleCheckerService.check();
  }

  private redirectTo(store: StoreSummary) {
    if (this.router.url.includes('store-details')) {
      this.router.navigate(['store-details', store.slug]);
    } else if (this.router.url.includes('employees')) {
      this.router.navigate(['employees', store.slug]);
    } else {
      this.router.navigate(['stores', store.slug]);
    }
  }
}
